module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "position": "absolute",
      "color": "white",
      "right": "10px",
      "top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    style: (_vm.bannerStyle)
  }, [_c('img', {
    staticClass: "gfb-logo",
    attrs: {
      "src": _vm.logoPath
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "87%",
      "position": "fixed",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-trans pull-left",
    staticStyle: {
      "height": "100%",
      "width": "50%",
      "padding-right": "1%",
      "border-right": "solid 2px",
      "min-height": "88vh"
    }
  }, [(_vm.headerLeft) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "4.5vh",
      "font-weight": "800",
      "border-bottom": "solid 2px",
      "border-color": "black",
      "margin": "-15px 15px 15px 15px",
      "padding-top": "0.8vh",
      "padding-bottom": "0.1vh",
      "background-color": "#E87524",
      "color": "white"
    }
  }, [(_vm.logoLeftPath) ? _c('img', {
    staticStyle: {
      "margin": "-1vh 3vh 1vh 0px",
      "height": "8vh"
    },
    attrs: {
      "src": _vm.logoLeftPath
    }
  }) : _vm._e(), _vm._v("\r\n          " + _vm._s(_vm.headerLeft) + "\r\n        ")]) : _vm._e(), _vm._v(" "), _c('swiper', {
    ref: "panelFlipperLeft",
    attrs: {
      "options": _vm.swiperOptionh
    }
  }, _vm._l((_vm.pagesLeft), function(page, pIndex) {
    return _c('slide', [_c('swiper', {
      ref: 'orderPanelLeft' + pIndex,
      refInFor: true,
      staticStyle: {
        "padding-left": "2%"
      },
      attrs: {
        "options": _vm.swiperOption
      }
    }, [_vm._l((_vm.pagesLeft[pIndex]), function(order, index) {
      return (!order.hidden) ? _c('slide', {
        ref: 'slide' + order.checkdetails.chk_num,
        refInFor: true
      }, [_c('div', {
        ref: 'order' + order.checkdetails.chk_num,
        refInFor: true,
        class: {
          'panel': true,
          'panel-default': true,
          'box-shadow': true,
          'in-prep': (order.status.indexOf('prep') >= 0),
          'pulse-order': (order.status.indexOf('ready') >= 0),
          'ready': (order.status.indexOf('ready') >= 0),
          'cashier': (order.status.indexOf('cashier') >= 0),
          'panel-trans': _vm.panelAnimation[index],
            'panel-shrinking': _vm.panelShrink[index],
            'panel-fade': _vm.panelFade[index]
        },
        staticStyle: {
          "margin": "2px 0px",
          "border": "none"
        }
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [_c('span', {
        staticClass: "display-name truncate"
      }, [_vm._v(_vm._s(order.displayName))]), _vm._v(" "), _c('span', {
        staticClass: "order-status",
        style: ('color: ' + order.color + ';')
      }, [_vm._v(_vm._s(_vm.$t(order.status) || ''))])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_c('orderitems', {
        ref: 'orderItems' + order.checkdetails.chk_num,
        refInFor: true,
        attrs: {
          "orderId": parseInt(order.checkdetails.chk_num),
          "customerName": order.checkdetails.id,
          "inGFB": true
        },
        on: {
          "updateOrder": _vm.updateOrder,
          "hideOrder": _vm.hideOrder
        }
      })], 1)]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination",
      attrs: {
        "slot": "pagination"
      },
      slot: "pagination"
    })], 2)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-trans pull-right",
    staticStyle: {
      "height": "100%",
      "width": "49%",
      "padding-right": "1%"
    }
  }, [(_vm.headerRight) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "4.5vh",
      "font-weight": "800",
      "border-bottom": "solid 2px",
      "border-color": "black",
      "margin": "-15px 15px 15px 15px",
      "padding-top": "0.8vh",
      "padding-bottom": "0.1vh",
      "background-color": "#E87524",
      "color": "white"
    }
  }, [(_vm.logoRightPath) ? _c('img', {
    staticStyle: {
      "margin": "0vh 3vh 0vh 0px",
      "height": "8vh"
    },
    attrs: {
      "src": _vm.logoRightPath
    }
  }) : _vm._e(), _vm._v("\r\n          " + _vm._s(_vm.headerRight) + "\r\n        ")]) : _vm._e(), _vm._v(" "), _c('swiper', {
    ref: "panelFlipperRight",
    attrs: {
      "options": _vm.swiperOptionh
    }
  }, _vm._l((_vm.pagesRight), function(page, pIndex) {
    return _c('slide', [_c('swiper', {
      ref: 'orderPanelRight' + pIndex,
      refInFor: true,
      staticStyle: {
        "padding-left": "2%"
      },
      attrs: {
        "options": _vm.swiperOption
      }
    }, [_vm._l((_vm.pagesRight[pIndex]), function(order, index) {
      return (!order.hidden) ? _c('slide', {
        ref: 'slide' + order.checkdetails.chk_num,
        refInFor: true
      }, [_c('div', {
        ref: 'order' + order.checkdetails.chk_num,
        refInFor: true,
        class: {
          'panel': true,
          'panel-default': true,
          'box-shadow': true,
          'in-prep': (order.status.indexOf('prep') >= 0),
          'pulse-order': (order.status.indexOf('ready') >= 0),
          'ready': (order.status.indexOf('ready') >= 0),
          'cashier': (order.status.indexOf('cashier') >= 0),
          'panel-trans': _vm.panelAnimation[index],
            'panel-shrinking': _vm.panelShrink[index],
            'panel-fade': _vm.panelFade[index]
        },
        staticStyle: {
          "margin": "2px 0px",
          "border": "none"
        }
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [_c('span', {
        staticClass: "display-name truncate"
      }, [_vm._v(_vm._s(order.displayName))]), _vm._v(" "), _c('span', {
        staticClass: "order-status",
        style: ('color: ' + order.color + ';')
      }, [_vm._v(_vm._s(_vm.$t(order.status) || ''))])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_c('orderitems', {
        ref: 'orderItems' + order.checkdetails.chk_num,
        refInFor: true,
        attrs: {
          "orderId": parseInt(order.checkdetails.chk_num),
          "customerName": order.checkdetails.id,
          "inGFB": true
        },
        on: {
          "updateOrder": _vm.updateOrder,
          "hideOrder": _vm.hideOrder
        }
      })], 1)]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination",
      attrs: {
        "slot": "pagination"
      },
      slot: "pagination"
    })], 2)], 1)
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "bottom": "5px",
      "width": "100%",
      "z-index": "20"
    }
  }, [_c('div', {
    staticClass: "col col-sm-2 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-lg pull-right btn-default",
    staticStyle: {
      "height": "24px",
      "width": "24px",
      "padding": "0px 3px 2px 3px",
      "font-weight": "bold",
      "border-radius": "50%",
      "background-color": "gold",
      "border": "none",
      "color": "#ED1C24"
    },
    attrs: {
      "disabled": _vm.logoutTimeout
    },
    on: {
      "click": function($event) {
        return _vm.gotoInfo()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle pull-left",
    staticStyle: {
      "margin": "2px 5px 0px 0px"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b184d43e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuestFacingBoard.vue
// module id = 535
// module chunks = 2